import { Component, OnInit } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';
import {
  Router,
  RouterLinkActive,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ScrollTopModule } from 'primeng/scrolltop';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { AllpathsComponent } from './allpaths/allpaths.component';
import { NotificationManagerComponent } from './stocks/notification-manager/notification-manager.component';
declare function require(moduleName: string): any;
const { version: appVersion, dependencies } = require('../../package.json');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterLinkActive,
    RouterLink,
    NotificationManagerComponent,
    AllpathsComponent,
    RouterOutlet,
    NgxSpinnerComponent,
    ScrollTopModule,
  ],
})
export class AppComponent implements OnInit {
  public appVersion;
  environment = environment;
  userLoggedIn = false;
  title = '';
  public angularVersion;
  constructor(
    private router: Router,
    private dataService: DataService,
    private titleName: Title
  ) {
    // this.dataService.autoLogin();
    this.appVersion = appVersion;
    this.angularVersion = dependencies['@angular/core']?.replace('^', '');
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }
  ngOnInit(): void {
    const firebaseConfig = {
      apiKey: environment.apiKey,
      authDomain: environment.authDomain,
      databaseURL: environment.databaseURL,
      projectId: environment.projectId,
      storageBucket: environment.storageBucket,
      messagingSenderId: environment.messagingSenderId,
      appId: environment.appId,
      measurementId: environment.measurementId,
    };
    const app = initializeApp(firebaseConfig);
    // this.dataService.autoLogin();
    this.dataService.userLogged$.subscribe((data) => {
      console.log(data);
      this.userLoggedIn = data;
      this.setHome();

      this.title = this.getTitle();
    });
  }
  getTitle() {
    return this.titleName.getTitle();
  }
  // title = 'My Dashboard';
  logout() {
    this.dataService.setLoggedUser(undefined);
    this.router.navigate(['/login']);
  }
  setHome() {
    this.titleName.setTitle('My Dashboard');
  }

  connectedToProd() {
    return this.environment.sLnk.includes('prod');
  }
}
